import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import router from '../../router';
import axios from 'axios';
import { Frictionless } from './frictionless';
import { Referral } from './referral';
import { ReferralPayload } from './referralPayload';
import { ReferralSuccess } from './referralSuccess';
import { RecaptchaResponse } from './recaptchaResponse';
import { JobReferralWrapper } from '../jobs/jobreferralwrapper';
import { RecruiterRequest } from './recruiterrequest';
import { RecruiterResponse } from './recruiterresponse';
import { ReferFriendRequest } from './referfriendreqest';
import { EmployeeReferralResponse } from './employeereferralresponse';
import { vxm } from '@/store.vuex';
import { GoogleContactResponse } from '../socialmedia/googlecontactresponse';
import { Company } from '../company/companyprofile';
import { CandidatePortalClientCommonInfo } from '../utility/lookup';
import { ReferralStats } from './referralStats';
import { User } from '../userdata/userdto';
import { SpecialityList } from '../../models/referrals/SpecialityList';
import { InternalReferralFriendRequest } from './internalReferralFriendRequest';
declare var window: any;

@Module({ namespacedPath: 'referrals/' })
export class ReferralStore extends VuexModule {
  private globalReferalCode: string = '';
  private frictionLessReferral: Frictionless = new Frictionless();
  private referral: Referral = new Referral();
  private referralSuccess: ReferralSuccess = new ReferralSuccess();
  private jobPostingId: number = 0;
  private recaptchaResp: RecaptchaResponse = new RecaptchaResponse();
  private jobReferralWrapper: JobReferralWrapper = new JobReferralWrapper();
  private googleContacts: string = '';
  private recruiterResponse: RecruiterResponse = new RecruiterResponse();
  private employeeReferralResponse: EmployeeReferralResponse = new EmployeeReferralResponse();
  private googleContactResponse: GoogleContactResponse = new GoogleContactResponse();
  private selectedJobForReferral: string = '';
  private specialityList: SpecialityList[] = new Array;
  private jobReferralDetails = {
    userReferralDetail: {
      referredUserList: [],
    },
  };
  private referralStats: ReferralStats = new ReferralStats();
  private referredUserData: Referral = new Referral();

  public get getJobReferralDetails() {
    return this.jobReferralDetails;
  }

  public get getRefferedJob(): string {
    return this.selectedJobForReferral;
  }
  public get getReferralStats() {
    return this.referralStats;
  }

  public get GoogleContactResponse(): GoogleContactResponse {
    return this.googleContactResponse;
  }

  public get jobId(): number {
    return this.jobPostingId;
  }

  
  public get getReferredUserData(): Referral {
    return this.referredUserData;
  }

  public get getReferralSuccess(): ReferralSuccess {
    return this.referralSuccess;
  }

  public get globalRefCode(): string {
    if (this.globalReferalCode) {
      return this.globalReferalCode;
    } else {
      return '';
    }
  }

  public get getFrictionless(): Frictionless {
    return this.frictionLessReferral;
  }

  public get getReferral(): Referral {
    return this.referral;
  }

  public get RecaptchaResponse(): RecaptchaResponse {
    return this.recaptchaResp;
  }

  public get ReferralWrapper(): JobReferralWrapper {
    return this.jobReferralWrapper;
  }

  public get GoogleContacts() {
    return this.googleContacts;
  }

  public get RecruiterResponse(): RecruiterResponse {
    return this.recruiterResponse;
  }

  public get EmployeeReferralResponse(): EmployeeReferralResponse {
    return this.employeeReferralResponse;
  }

  public get getSpecialityList(): SpecialityList[] {
    return this.specialityList;
  }

  ////////////////////////////////////////////////////////
  @mutation
  setPromoteReferral({ appShareInfo, referralCode, referralURL }) {
    this.referralSuccess.referralCode = referralCode;
    this.referralSuccess.referralUrl = referralURL;
    this.referralSuccess.appShareInfo = appShareInfo
  }

  @mutation
  public setReferralStats(payload) {
    this.referralStats.referrals = payload.referrals;
    this.referralStats.totalFixedPoints = payload.totalFixedPoints;
    this.referralStats.totalVariablePoints = payload.totalVariablePoints;
    this.referralStats.variableIncentiveEnabled = payload.variableIncentiveEnabled;
    this.referralStats.incentiveQuantityUOM =
      payload.incentiveQuantityUOM ||
      vxm.configs.getCompanyPreference('CURRENCY', 'companyCurrency');

    this.referralStats.referralLevels = payload.referralLevels;
  }

  @mutation
  public setRefferedJob(jobname: string) {
    console.log('***Setting Job', jobname);
    this.selectedJobForReferral = jobname;
  }

  @mutation
  public setGoogleContactResponse(gcr: GoogleContactResponse) {
    this.googleContactResponse = gcr;
  }

  @mutation
  public setGlobalRefCode(grc: string) {
    this.globalReferalCode = grc;
  }

  @mutation
  public setJobID(JobID: number) {
    this.jobPostingId = JobID;
  }

  @mutation
  public setFrictionless(flr: Frictionless) {
    this.frictionLessReferral = flr;
  }

  @mutation
  public setReferral(ref: Referral) {
    this.referral = ref;
  }

  @mutation
  public setReferralSuccess(ref: ReferralSuccess) {
    this.referralSuccess = ref;
  }

  @mutation
  public setReferredUserData(ref: Referral) {
    this.referredUserData = ref;
  }

  @mutation
  public setRecaptchaResponse(res: RecaptchaResponse) {
    this.recaptchaResp = res;
  }

  @mutation
  public setJobReferralWrapper(jrw: JobReferralWrapper) {
    this.jobReferralWrapper = jrw;
  }

  @mutation
  public setGoogleContacts(contacts: string) {
    this.googleContacts = contacts;
  }

  @mutation
  public setRecruiterResponse(rr: RecruiterResponse) {
    this.recruiterResponse = rr;
  }

  @mutation
  public setJobReferralDetails(payload: any) {
    this.jobReferralDetails.userReferralDetail.referredUserList =
      payload.userReferralDetail.referredUserList ||
      payload.userReferralDetail.referFriendDetails ||
      [];
  }

  @mutation
  public setEmployeeReferralResponse(er: EmployeeReferralResponse) {
    this.employeeReferralResponse = er;
  }

  @mutation
  public setSpecialityList(obj: any) {
    this.specialityList = obj.data.content;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getJobReferral(payload: CandidatePortalClientCommonInfo) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/referral/referraldetail',
      payload,
      { headers: { 'Content-Type': 'application/json' } },
    );
    let JWrapper = new JobReferralWrapper();
    JWrapper = resp.data;
    this.setJobReferralWrapper(JWrapper);
    this.setJobReferralWrapper(JWrapper);
    if (this.jobReferralWrapper.referralCode) {
      this.setGlobalRefCode(JWrapper.referralCode);
    }
    return JWrapper;
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async fetchSpecialityList() {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/referral/specialityList',
      {
        "searchText":"",
        "pageNumber":1,
        "pageSize":5
      },
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    this.setSpecialityList(resp.data);
  }

  //////////////////////////////////////////////////////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async fetchInternalSpecialityList() {
    const resp = await axios.post(
      '/wl-profile-svc/anon/api/referral/specialityList',
      {
          "searchText":"",
          "pageNumber":1,
          "pageSize":5,
          "companyCode" : vxm.jobs.BrandingInfo.companycode
      },
      {
        headers: {
            'Content-Type': 'application/json'
        },
      },
    );
    this.setSpecialityList(resp.data);
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getRecruiterList(recruiterPayload: RecruiterRequest) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/referral/getRecruiterList',
      recruiterPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let rr = new RecruiterResponse();
    rr = resp.data;
    this.setRecruiterResponse(rr);
    return rr;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getRecruiterListByCompany(recruiterPayload: RecruiterRequest) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/referral/getRecruiterListByCompany',
      recruiterPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let rr = new RecruiterResponse();
    rr = resp.data;
    this.setRecruiterResponse(rr);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async referTheFriend(payload) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/api/v2/referral/referafriend',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let er = new EmployeeReferralResponse();
    er = resp.data;
    this.setEmployeeReferralResponse(er);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async internalReferFriend(referFriendRequest: InternalReferralFriendRequest) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    console.log(vxm.utmtracker.utmTrackerId, "utmTrackerId");
    if (vxm.utmtracker.utmTrackerId > 0) {
      referFriendRequest.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    const resp = await axios.post(
      '/wl-profile-svc/api/referral/friend',
      referFriendRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let er = new EmployeeReferralResponse();
    er = resp.data;
    this.setEmployeeReferralResponse(er);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getAnonRecruiterList(recruiterPayload: RecruiterRequest) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/anon/referral/getRecruiterList',
      recruiterPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let rr = new RecruiterResponse();
    rr = resp.data;
    this.setRecruiterResponse(rr);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getAnonRecruiterListByCompany(
    recruiterPayload: RecruiterRequest,
  ) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/anon/referral/getRecruiterListByCompany',
      recruiterPayload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let rr = new RecruiterResponse();
    rr = resp.data;
    this.setRecruiterResponse(rr);
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async anonReferTheFriend(payload) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    const resp = await axios.post(
      '/wl-profile-svc/anon/v2/referral/referafriend',
      payload,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let er = new EmployeeReferralResponse();
    er = resp.data;
    this.setEmployeeReferralResponse(er);
  }

  
  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async anonInternalReferTheFriend(referFriendRequest: ReferFriendRequest) {
    const bearerToken = 'Bearer ' + vxm.users.getToken;
    console.log(vxm.utmtracker.utmTrackerId, "utmTrackerId");
    if (vxm.utmtracker.utmTrackerId > 0) {
      referFriendRequest.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    const resp = await axios.post(
      '/wl-profile-svc/anon/api/referral/friend',
      referFriendRequest,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
    let er = new EmployeeReferralResponse();
    er = resp.data;
    this.setEmployeeReferralResponse(er);
    return er;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async postReferral(referralPayload: ReferralPayload) {
    const bearerToken = 'Bearer ' + referralPayload.token;
    const resp = await axios.post(
      '/wl-jobs-svc/api/v1/referrals',
      referralPayload.referral,
      {
        headers: {
          'Content-Type': 'application/json',
          Authorization: bearerToken,
        },
      },
    );
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async postFrictionlessReferral(referralPayload: Frictionless) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/referral/sendemail',
      referralPayload,
      { headers: { 'Content-Type': 'application/json' } },
    );
    return resp.data;
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async postFrictionlessNewReferral(
    referFriendBody: FormData,
  ) {
    let er = new EmployeeReferralResponse();
    try {
      const resp = await axios.post(
        '/wl-jobs-svc/api/anon/referral/sendjobreferral',
        referFriendBody
      );
      er = resp.data;
      this.setEmployeeReferralResponse(er);
      return resp.data;
    }
     catch (error) { 
      er = error.response.data;
      this.setEmployeeReferralResponse(er);
      return error.response.data
    }

  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async jobShareReferral(referralPayload: Referral) {
    console.log(vxm.utmtracker.utmTrackerId, 'utmTrackerId');
    if (vxm.utmtracker.utmTrackerId > 0) {
      referralPayload.utmTrackerId = vxm.utmtracker.utmTrackerId;
    }
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/referral',
      referralPayload,
      { headers: { 'Content-Type': 'application/json' } },
    );

    const hostName = location.href.split('/')[2];
    console.log(hostName);
    resp.data.referralUrl = resp.data.referralUrl.replace(
      'devatsu.nuvizzards.com',
      hostName,
    );
    this.setReferralSuccess(resp.data);
    this.setReferredUserData(referralPayload);
    router.push({ name: 'Invite' });
    console.log(resp.data);
  }

  @action({ mode: 'mutate' })
  public async userQuickRegister(userPayload: User) {
    const resp = await axios.post('/atsuser/quickSignup', userPayload, {
      headers: { 'Content-Type': 'application/json' },
    });
    console.log(resp.data);
    router.push({ path: 'submitquicksignup' });
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getGoogleContacts(ccode: string) {
    const resp = await axios.post(
      '/wl-sso-sec-svc/getGoogleContactsv2?companycode=' +
        vxm.jobs.BrandingInfo.companycode,
      ccode,
      {
        headers: { 'Content-Type': 'application/json' },
      },
    );
    console.log(resp.data);
    this.setGoogleContactResponse(resp.data);
    router.push({ name: 'Invite' });
  }

  ////////////////////////////////////////////////////////

  @action({ mode: 'mutate' })
  public async getRecaptchaResponse(token: string) {
    const resp = await axios.post(
      '/wl-sso-sec-svc/getRecaptchaResponse',
      token,
      { headers: { 'Content-Type': 'application/json' } },
    );

    const recaptchaResponse = new RecaptchaResponse();
    recaptchaResponse.success = resp.data.success;
    recaptchaResponse.hostname = resp.data.hostname;
    recaptchaResponse.timestamp = resp.data.timestamp;
    this.setRecaptchaResponse(recaptchaResponse);
  }

  @action({ mode: 'mutate' })
  public async checkQuickSignupUserexist(referralPayload: Referral) {
    const resp = await axios.post(
      '/wl-jobs-svc/api/anon/referral/checkquicksignupuserexist',
      referralPayload,
      { headers: { 'Content-Type': 'application/json' } },
    );

    console.log(resp.data);
    return resp.data;
  }
  @action({ mode: 'mutate' })
  public async fetchReferralStats(payload) {
    this.setJobReferralDetails({
      userReferralDetail: { referredUserList: [] },
    });
    const token = vxm.users.getToken;
    const response = await axios.post(
      '/wl-profile-svc/api/v2/myreferral/referralstats',
      {
        sessionToken: null,
        referralStatsFilter: {
          includeExpiredJobs: false,
          keywords: payload.searchString,
          sortBy: { ascending: payload.ascending, sortByField: 'RecentDate' },
        },
        resultSize: 1000,
        resultPage: 1,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    this.setReferralStats(response.data);
  }
  @action({ mode: 'mutate' })
  public async fetchReferralDetails(payload) {
    this.setJobReferralDetails({
      userReferralDetail: { referredUserList: [] },
    });
    const token = vxm.users.getToken;
    const response: any = await axios.post(
      '/wl-profile-svc/api/v2/myreferral/referraldetails',
      {
        sessionToken: null,
        referringUserLevel: 1,
        referralCode: payload.referralCode,
        sendHeaderInfo: true,
        resultSize: 10,
        resultPage: 1,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    this.setJobReferralDetails(response.data);
  }
  @action({ mode: 'mutate' })
  public async fetchAppReferralDetails(payload) {
    this.setJobReferralDetails({
      userReferralDetail: { referredUserList: [] },
    });
    const token = vxm.users.getToken;
    const response: any = await axios.post(
      '/wl-profile-svc/api/v2/myreferral/appreferraldetails',
      { sessionToken: null, referralCode: payload.referralCode },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    let referredUserList: Array<Object> = [];
    const JOB_STATUS_MAPPING = {
      referredUserList: '-10',
      registeredUserList: '00',
      offeredUserList: '50',
      hiredUserList: '90',
      appliedUserList: '10',
    };
    const STATUS_ARRAY = [
      'registeredUserList',
      'appliedUserList',
      'offeredUserList',
      'hiredUserList',
      'referredUserList',
    ];
    STATUS_ARRAY.map((status) => {
      response.data.llamaReferralDetail[status] &&
        response.data.llamaReferralDetail[status].map((user) => {
          user.userJobStatus = JOB_STATUS_MAPPING[status];
          referredUserList.push(user);
        });
    });
    this.setJobReferralDetails({
      userReferralDetail: { referredUserList },
    });
  }
  @action({ mode: 'mutate' })
  public async fetchPromotereferral() {
    const token = vxm.users.getToken;
    const response = await axios.post(
      '/wl-profile-svc/api/v1/myreferral/promotereferral',
      {
        sessionToken: null,
        companyCode: vxm.users.getCompanyCode,
        jobPostingId: null,
        appShare: true,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
    console.log(response.data.referralDetail);
    this.setPromoteReferral(response.data.referralDetail);
  }
}
